import React, { memo } from "react";

function AvisoTiendaCerrada({ estadoTienda }) {
  if (!estadoTienda || estadoTienda.abierta) {
    return null;
  }

  return (
    <div
      style={{
        margin: "12px 16px 0 16px",
        backgroundColor: "#fff8e1",
        border: "1px solid #ffe0a3",
        borderRadius: "14px",
        padding: "12px 14px",
        boxShadow: "0 3px 10px rgba(0,0,0,0.04)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
        }}
      >
        <div
          style={{
            width: "34px",
            height: "34px",
            borderRadius: "999px",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            flexShrink: 0,
            border: "1px solid #f3dfb5",
          }}
        >
          ⏰
        </div>

        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: "13px",
              fontWeight: "900",
              color: "#7a4b00",
              marginBottom: "3px",
            }}
          >
            La tienda está cerrada por ahora
          </div>

          <div
            style={{
              fontSize: "12px",
              color: "#7a4b00",
              lineHeight: "1.4",
              fontWeight: "700",
            }}
          >
            {estadoTienda.mensaje ||
              "Puedes revisar el menú, pero por ahora no estamos recibiendo pedidos."}
          </div>

          {estadoTienda.reaperturaTexto && (
            <div
              style={{
                marginTop: "5px",
                fontSize: "12px",
                color: "#9a5c1f",
                lineHeight: "1.4",
                fontWeight: "900",
              }}
            >
              {estadoTienda.reaperturaTexto}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default memo(AvisoTiendaCerrada);
